import { Navigate, Outlet, useLocation, useNavigate } from "react-router-dom";
import { useStore } from "../../store/Store";
import { useEffect, useState } from "react";
import { useLoaderStore } from "../../Services/LoaderService";
import { authService } from "../../Services/auth/auth.service";
import bgImage from "../../assets/images/login/bg.png";
import userEmailImage from "../../assets/images/login/userEmail.svg";
import passwordImage from "../../assets/images/login/password.svg";
import logoWhite from "../../assets/images/login/logo-white.png";
import announcementImage from "../../assets/images/login/announcement.png";
import loginRightImage from "../../assets/images/login/loginRightImage.svg";
import { lookUpService } from "../../Services/common/lookup.service";
import FormSelect from "../../Components/FormTag/FormSelect";
import { useForm } from "react-hook-form";
import { SelcetOption } from "../../model/common/apiResponse";
import { ChevronDown, ChevronUp } from "react-bootstrap-icons";

const UserLogin = () => {
  const { login, logout, switchAccount } = authService();
  const navigate = useNavigate();
  const { setLoading } = useLoaderStore();
  const location = useLocation();

  const [error, setError] = useState<string | null>(null);
  const [username, setUsername] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [showAccountListing, setShowAccountListing] = useState<boolean>(false);
  const [accountList, setAccountList] = useState<any>([]);
  const [showMoreAnnouncement, setShowMoreAnnouncement] =
    useState<boolean>(false);

  const {
    register,
    reset,
    setValue,
    control,
    clearErrors,
    trigger,
    formState: { errors, isValid },
  } = useForm<any>({
    mode: "onChange",
  });

  const checkAuth = () =>
    !!localStorage.getItem("token") &&
    !!localStorage.getItem("apiSessionStorage") &&
    !!localStorage.getItem("account");

  const [isAuthenticated, setIsAuthenticated] = useState(checkAuth());

  useEffect(() => {
    setIsAuthenticated(checkAuth());

    const handleAuthChange = () => {
      setIsAuthenticated(checkAuth());
    };

    window.addEventListener("authChange", handleAuthChange);
    window.addEventListener("storage", handleAuthChange);

    return () => {
      window.removeEventListener("authChange", handleAuthChange);
      window.removeEventListener("storage", handleAuthChange);
    };
  }, [location]);

  if (isAuthenticated && localStorage.getItem("account") == "1") {
    return <Navigate to="/" replace />;
  }

  const handleSubmit = async () => {
    if (!username || !password) {
      setError("Username and password are required.");
      return;
    }

    try {
      setLoading(true);
      const response = await login(username, password);
      if (response && response.data.account) {
        navigate("/dashboard");
      } else if (response && !response.data.account) {
        fetchAccount();
      } else {
        setError("Incorrect username or password. Please try again.");
      }
    } catch (err) {
      setError("Incorrect username or password. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const fetchAccount = async () => {
    setShowAccountListing(true);
    const response = await lookUpService.getAccounts();
    const accountData: SelcetOption[] = response.data?.data?.results.map(
      (obj: any) => ({
        label: obj.name,
        value: obj.code,
      })
    );
    setAccountList(accountData);
  };

  const handleSwitchAccount = async (selectedOption: any) => {
    const response = await switchAccount(selectedOption.value);
    if (response && response.data.account) {
      navigate("/dashboard");
    }
  };

  const toggleAnnouncementView = () => {
    setShowMoreAnnouncement(!showMoreAnnouncement);
  };

  return (
    <>
      <div className="bodyBg">
        <img src={bgImage} alt="" />
      </div>
      <div className="container-fluid bodyCover">
        <div className="container d-flex justify-content-center align-items-center flex-column h-100 pb-0 mt-0">
          <div className="container d-flex loginBG">
            <div className="LeftLogin col-12 col-sm-7 p-lg-2 p-md-2 p-0 d-flex justify-content-center align-items-center">
              {!showAccountListing ? (
                <>
                  <form
                    className="p-lg-5 px-md-5 py-3 px-4 w-100"
                    onKeyDown={(e) => e.key === "Enter" && handleSubmit()}
                  >
                    <div className="LoginTitle pb-4 text-start"> Sign In </div>
                    {error && (
                      <div className="error-message text-danger">{error}</div>
                    )}
                    <div className="mb-3 text-start">
                      <label className="UsernameTitle">Username</label>
                      <div className="input-group-login">
                        <img
                          src={userEmailImage}
                          className="userEmailImage"
                          alt=""
                        />
                        <input
                          className="userEmail"
                          id="email"
                          placeholder="Enter username"
                          type="text"
                          onChange={(e) => setUsername(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="mb-3 text-start">
                      <label className="UsernameTitle">Password</label>
                      <div className="input-group-login">
                        <img
                          src={passwordImage}
                          className="userEmailImage"
                          alt=""
                        />
                        <input
                          type="password"
                          className="userEmail"
                          id="password"
                          placeholder="Enter password"
                          onChange={(e) => setPassword(e.target.value)}
                          required
                        />
                      </div>
                    </div>
                    <div className="d-flex flex-column justify-content-center align-items-center mt-5">
                      <button
                        type="button"
                        onClick={handleSubmit}
                        className="btn btn-primary SignIn-button mb-3"
                      >
                        <span className="SignIn-button-text">SIGN IN</span>
                      </button>
                      <button
                        type="button"
                        className="btn btn-link forgot-button-text"
                      >
                        Forgot your Password?
                      </button>
                    </div>
                  </form>
                </>
              ) : (
                <>
                  <div className="container AccountListing px-4 w-75 text-start">
                    <label className="account-select-label float-left">
                      Select an Account
                    </label>
                    <FormSelect
                      name="warehouse"
                      tabIndex={2}
                      control={control}
                      optionList={accountList ?? []}
                      className="form-control p-0 "
                      placeholder="Select an Account"
                      selectedOption={handleSwitchAccount}
                    />
                  </div>
                </>
              )}
            </div>
            <div className="container RightLogin col-5 p-0 d-none d-sm-block">
              <div className="RightLoginLogo">
                <img src={logoWhite} alt="" />
              </div>
              <div className="container LoginParagraphSection px-4 pt-4">
                <div className="AnnouncementTitleSection pb-3">
                  <img src={announcementImage} alt="" />
                  <label className="AnnouncementTitle ps-2 ps-md-3">
                    Announcement
                  </label>
                </div>

                {/* First paragraph always visible */}
                <p className="AnnouncementParagraph1 pe-0 pe-md-5">
                  SphereWMS empowers warehouse operators with real-time
                  visibility, control, and flexibility across every stage of
                  their operation.
                </p>

                {/* Second paragraph only shows on larger screens OR when expanded */}
                <p
                  className={`AnnouncementParagraph2 pe-5 ${
                    showMoreAnnouncement ? "d-block" : "d-none d-lg-block"
                  }`}
                >
                  Our cloud-based platform delivers intuitive dashboards and
                  powerful reporting tools, giving you instant insight into
                  inventory levels, order statuses, and warehouse performance.
                  {showMoreAnnouncement && (
                    <p className="mt-1">
                      Seamless integrations with ERP, eCommerce, shipping, and
                      accounting systems keep your data synchronized and your
                      workflows streamlined. With mobile accessibility built in,
                      your team can manage warehouse activities from anywhere,
                      increasing efficiency and responsiveness. Whether you’re
                      running a 3PL, distribution center, or eCommerce business,
                      SphereWMS helps you optimize operations, reduce costs, and
                      exceed customer expectations.
                    </p>
                  )}
                </p>

                {/* View More / Less Toggle */}
                <a
                  className="AnnouncementMore text-white"
                  onClick={toggleAnnouncementView}
                  style={{ cursor: "pointer" }}
                >
                  {showMoreAnnouncement ? "View Less " : "View More "}
                  {showMoreAnnouncement ? <ChevronUp /> : <ChevronDown />}
                </a>
              </div>

              {/* Image Section Hidden When showMoreAnnouncement is True */}
              <div
                className={`container LoginImageSection px-0 pt-4 ${
                  showMoreAnnouncement ? "d-none" : ""
                }`}
              >
                <div className="LoginImage d-flex justify-content-end">
                  <img src={loginRightImage} alt="" />
                </div>
              </div>
            </div>
          </div>
          <div className="container d-flex justify-content-center CopyrightLogin">
            <span>Copyright © 2022 SphereWMS. All Rights Reserved</span>
          </div>
        </div>
      </div>
    </>
  );
};

export default UserLogin;
